import { jwtDecode } from 'jwt-decode'

export const TOKEN_COOKIE = 'UniqApi.Token'

/**
 * The raw JWT from the auth cookie, or '' when absent. The cookie cannot be HttpOnly - the
 * request interceptor reads it to stamp the Authorization header.
 */
export function getAuthToken() {
  const entry = document.cookie.split('; ').find(c => c.startsWith(`${TOKEN_COOKIE}=`))
  return entry ? entry.slice(TOKEN_COOKIE.length + 1) : ''
}

/**
 * Present AND not past its own `exp`. Presence alone is not a session: an expired token that
 * passes the router gate lets App.vue fire its whole bootstrap into a burst of 401s instead of
 * redirecting to the login page.
 *
 * Lives here, not in router/index.js, so the auth route guards can use it without importing the
 * router - which builds its route table from those same modules.
 */
export function hasValidAuthToken() {
  const token = getAuthToken()
  if (!token) return false

  try {
    const { exp } = jwtDecode(token)
    // No exp means we cannot prove it is expired - let the API be the judge.
    return !exp || exp * 1000 > Date.now()
  } catch (e) {
    return false
  }
}

export default { TOKEN_COOKIE, getAuthToken, hasValidAuthToken }
